// extracted by mini-css-extract-plugin
module.exports = {"dateTime":"DateTime_dateTime__1tMHW"};